import { Component, Inject } from '@angular/core';

import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { StorageObjectType } from 'src/app/shared/enums/StorageFileType.enum';
import { HoldingStorageObjectReqRes } from 'src/app/shared/models/StorageObjectReqRes.model';
import { FileMenuOption } from '../FileMenuOption.enum';

@Component({
  selector: 'terra-file-options-menu',
  templateUrl: './file-options-menu.component.html',
  styleUrls: ['./file-options-menu.component.scss']
})
export class FileOptionsMenuComponent {
  // enums
  FileMenuOption = FileMenuOption;
  StorageObjectType = StorageObjectType;

  constructor(
    private _bottomSheetRef: MatBottomSheetRef<FileOptionsMenuComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public context: HoldingStorageObjectReqRes) {
  }

  select(selection: FileMenuOption, event: Event) {
    this._bottomSheetRef.dismiss(selection);
    event.preventDefault();
  }

  getFileName() {
    return this.context ? ` ${this.context.displayName}.${this.context.extension}` : ``;
  }
}
